import {
  defaultAllowedFileTypes,
  forbiddenCharacters,
} from '@shared/validators';

export function validateFile(
  file: File,
  options?: {
    maxNameLength?: number;
    maxSizeInGB?: number;
    allowedTypes?: string[];
    fieldName?: string;
  },
): string {
  const {
    maxNameLength = 255,
    maxSizeInGB = 1,
    allowedTypes = defaultAllowedFileTypes,
  } = options || {};

  const fileName = file.name.normalize('NFC');

  if (fileName.length < 1 || fileName.length > maxNameLength) {
    return 'invalidName';
  }

  if (fileName.endsWith('.')) {
    return 'trailingPeriod';
  }

  if ([...fileName].some((char) => forbiddenCharacters.includes(char))) {
    return 'forbiddenCharacters';
  }

  const extension = fileName.split('.').pop()?.toLowerCase();
  if (!extension || !allowedTypes.includes(extension)) {
    return 'invalidFileType';
  }

  const maxSizeInBytes = maxSizeInGB * 1024 * 1024 * 1024;
  if (file.size > maxSizeInBytes) {
    return 'fileTooLarge';
  }

  return 'valid';
}

export function groupFilesByValidation(
  files: File[],
  options?: Parameters<typeof validateFile>[1],
) {
  const result: Record<string, File[]> = {
    valid: [],
    invalidName: [],
    trailingPeriod: [],
    forbiddenCharacters: [],
    invalidFileType: [],
    fileTooLarge: [],
    required: [],
  };

  for (const file of files) {
    const validation = validateFile(file, options);
    result[validation]?.push(file);
  }

  for (const key in result) {
    if (result[key].length === 0) {
      delete result[key];
    }
  }

  return result;
}
